'use client'

import React from 'react'
import AnimatedSection from '@/components/AnimatedSection'
import Typography from '@/components/Typography'
import styles from './styles.module.css'

const OurApproach: React.FC = () => {
	return (
		<section className={styles.ourApproach}>
			<div className={styles.container}>
				<div className={styles.content}>
					<AnimatedSection animation="slideUp">
						<div className={styles.subtitle}>Наш подход</div>
						<h2 
							className={styles.title}
							dangerouslySetInnerHTML={{ __html: '<span>Проектируем логику,</span> а не просто связываем сервисы' }}
						/>
					</AnimatedSection>
					
					<AnimatedSection animation="slideUp">
						<Typography variant='p1' color='description' className={styles.description}>
							Мы начинаем с аудита ваших текущих процессов, чтобы понять, как данные перемещаются между отделами. Наш подход — создание надёжной архитектуры, которая исключает потерю информации и дублирование задач.<br /><br />Вы получаете систему, где каждый сервис знает своё место, а данные передаются мгновенно и без ошибок.
						</Typography>
					</AnimatedSection>
				</div>
			</div>
		</section>
	)
}

OurApproach.displayName = 'OurApproach'

export default OurApproach